import template from './views/navigation.html';
import './navigation.scss';
import controller from './controllers/navigationController';


const name = 'navigation';
var module = angular.module('app.navigation', [
    'angular-send-feedback'
]).component(name, {
    template: template,
    controller: controller,
    controllerAs: name
}).controller('navigationCtrl', controller);


module.constant('NAVIGATION_CONSTANTS', {
    API_GET_NOTIFICATION_HEADER_DETAILS: "/v0/notifications/header/details/",
    API_UPDATE_NOTIFICATION_TRACKER: "/v0/notifications/update/tracker",
    API_UPDATE_NOTIFICATION_STATUS: "/v0/notifications/update/status",
    API_GET_PERSON_DETAILS: "/v0/user/person/details/",
    API_GET_USER_DETAILS: "/v0/user/",
    API_GET_DICTIONARY_SEARCH: "/v0/dictionary/search/",
    API_ADD_BOOKMARK: "/v0/bookmark/add-bookmark",
    API_UPDATE_BOOKMARK: "/v0/bookmark/update-bookmark",
    API_DELETE_BOOKMARK: "/v0/bookmark/delete-bookmark/",
    API_IS_BOOKMARK: "/v0/bookmark/checkIsPageBookmarked",
    API_GET_GMAIL_INBOX_DETAILS: '/v0/gmail/inbox/',
    API_GET_WHATS_NEW: '/v0/dashboard/whatsnew/'
});

export default module;


// WEBPACK FOOTER //
// ./src/app/navigation/navigationModule.js